export default {
  label: 'Columns',
  columns: [],
  key: 'columns',
  type: 'columns',
  input: false,
  components: []
};
